"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.RadioGroup = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Radio = require("./Radio.style");

var _excluded = ["label", "description", "onChange", "disabled", "className", "checked", "color", "id"],
    _excluded2 = ["children"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Radio = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var label = _ref.label,
      description = _ref.description,
      onChange = _ref.onChange,
      disabled = _ref.disabled,
      className = _ref.className,
      checked = _ref.checked,
      color = _ref.color,
      id = _ref.id,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Radio.StyledRadio, {
    disabled: disabled,
    className: (0, _classnames["default"])(className, {
      center: !description
    }),
    checked: checked,
    tabIndex: 0,
    color: color,
    htmlFor: id
  }, /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({
    type: "radio",
    onChange: onChange,
    disabled: disabled,
    checked: checked,
    id: id
  }, props, {
    ref: ref
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "eui-radio-icon"
  }), (label || description) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "eui-radio-box"
  }, label && /*#__PURE__*/_react["default"].createElement("div", {
    className: "eui-radio-label"
  }, label), description && /*#__PURE__*/_react["default"].createElement("div", {
    className: "eui-radio-desc"
  }, description)));
});

var RadioGroup = function RadioGroup(_ref2) {
  var children = _ref2.children,
      props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
  return /*#__PURE__*/_react["default"].createElement(_Radio.StyledGroup, props, children);
};

exports.RadioGroup = RadioGroup;
RadioGroup.propTypes = {
  children: _propTypes["default"].node
};
Radio.defaultProps = {
  color: 'primary'
};
Radio.propTypes = {
  color: _propTypes["default"].oneOf(['primary', 'secondary']).isRequired,
  label: _propTypes["default"].string,
  description: _propTypes["default"].string,
  value: _propTypes["default"].string.isRequired,
  onChange: _propTypes["default"].func.isRequired,
  id: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  checked: _propTypes["default"].bool,
  className: _propTypes["default"].string
};
var _default = Radio;
exports["default"] = _default;